<template>
  <div>
    <v-row class="bradcrumb">
      <router-link :to="{ name: 'role-links' }" class="root">
        Dashboard
      </router-link>
      <span class="child">/ Import Proctro </span>
    </v-row>
    <br />
    <v-card class="card">
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-card-title class="heading">Import Proctor</v-card-title>
      <v-card class="box">
        <div class="flex">
          <div></div>
          <div>
            <a
              href="https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/AssignProctor_Sample_File.csv"
            >
              <v-btn
                :loading="loading3"
                :disabled="loading3"
                color="success"
                class="ma-2 white--text downbtn"
                @click="loader = 'loading3'"
              >
                <v-icon left dark>mdi-cloud-download</v-icon>Download import CSV
                format
              </v-btn>
            </a>
          </div>
        </div>
        <v-card-text>
          <v-row>
            <v-col cols="12" lg="6" sm="12">
              <v-autocomplete
                :items="examList"
                v-model="examid"
                item-value="examid"
                item-text="exam"
                label="Select Exam"
                :hint="lerid != null ? '' : 'Please Select Exam'"
                persistent-hint
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="6" sm="12" v-if="examid">
              <v-file-input
                v-model="file"
                :hint="file != null ? '' : 'Please Select File'"
                persistent-hint
                color="rgb(1, 127, 152)"
                label="Choose File"
                accept=".csv"
                prepend-icon="mdi-paperclip"
                outlined
                show-size
              >
              </v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" align="center">
              <v-btn @click="submitFile" :loading="output_load" class="button">
                Upload
                <v-icon right>mdi-cloud-upload</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <template>
        <v-data-table
          :headers="headers"
          class="elevation-1"
          :search="search"
          :items="dataList"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <download-excel
                class="mar"
                :data="dataList"
                :fields="export_table_headers"
                worksheet="ProctorList"
                name="ProctorData.xls"
              >
                <v-btn color="success" dark class="mb-2">
                  Export<v-icon dark>mdi-file-excel</v-icon>
                </v-btn>
              </download-excel>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <span style="width: 20px;"></span>
              <v-btn class="button" @click="dialog = true">
                <v-icon left>mdi-account-plus</v-icon>Assign Proctor
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:[`item.isactive`]="{ item }">
            <div>
              <v-icon v-if="item.isactive" color="green"
                >mdi-checkbox-marked-circle</v-icon
              >
              <v-icon v-else color="red">mdi-close-circle</v-icon>
            </div>
          </template>
          <template v-slot:[`item.edit`]="{ item }">
            <div>
              <v-avatar size="33" class="edit-avatar">
                <v-icon
                  color="rgb(1, 127, 152)"
                  size="18"
                  @click="editDialogFunction(item)"
                  >mdi-pencil</v-icon
                >
              </v-avatar>
            </div>
          </template>
        </v-data-table>
      </template>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title class="heading">
            <span>Assign New Proctor</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    :items="learnerList"
                    v-model="defaultItem.lerid"
                    item-value="lid"
                    item-text="grno"
                    label="Learner"
                    :hint="
                      defaultItem.lerid != null ? '' : 'Please Select Learner'
                    "
                    persistent-hint
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    :items="instList"
                    v-model="defaultItem.instid"
                    item-value="instid"
                    item-text="employee_code"
                    label="Proctor"
                    :hint="
                      defaultItem.instid != null ? '' : 'Please Select Proctor'
                    "
                    persistent-hint
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-autocomplete
                    :items="examList"
                    v-model="defaultItem.examid"
                    item-value="examid"
                    item-text="exam"
                    label="Exam"
                    :hint="
                      defaultItem.examid != null ? '' : 'Please Select Exam'
                    "
                    persistent-hint
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="button-cancel" text @click="dialog = false"
              >Close</v-btn
            >
            <v-btn class="button" text @click="saveProctor">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editDialog" persistent max-width="600px">
        <v-card>
          <v-card-title class="heading">
            <span>Edit Proctor Details</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-autocomplete
                    v-model="editedItem.lerid"
                    label="Select Learner"
                    :items="learnerList"
                    item-value="lid"
                    item-text="grno"
                    required
                    :hint="
                      editedItem.lerid != null ? '' : 'Please Select Learner'
                    "
                    persistent-hint
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="12">
                  <v-autocomplete
                    v-model="editedItem.instid"
                    label="Select Proctor"
                    item-value="instid"
                    item-text="employee_code"
                    :items="instList"
                    required
                    :hint="
                      editedItem.instid != null ? '' : 'Please Select Proctor'
                    "
                    persistent-hint
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="editedItem.examid"
                    label="Select Exam"
                    item-value="examid"
                    item-text="exam"
                    :items="examList"
                    required
                    :hint="
                      editedItem.examid != null ? '' : 'Please Select Exam'
                    "
                    persistent-hint
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    dense
                    v-model="editedItem.isactive"
                    color="success"
                    label="Active?"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="button-cancel" text @click="editDialog = false"
              >Close</v-btn
            >
            <v-btn class="button" text @click="editProctor">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <!-- failList -->
    <v-row justify="center">
      <v-dialog
        v-model="dialog_faildata"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar class="heading">
            <v-btn icon dark @click="dialog_faildata = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title style="color:#FFF;"
              >Proctor Not Assign</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <download-excel
                style="margin-top:10px;"
                :data="failList"
                :fields="table_"
                worksheet="Proctor_Not_Import"
                name="proctor_Not_Import.xls"
              >
                <v-btn class="ma-1 white--text" color="green">
                  <v-icon dark>
                    mdi-file-excel-box
                  </v-icon>
                  Export to Excel
                </v-btn>
              </download-excel>
              <v-btn dark text @click="dialog_faildata = false">
                Close
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-simple-table fixed-header height="800px">
            <template>
              <thead>
                <tr color="red">
                  <th class="text-left">Sr.No</th>
                  <th class="text-left">Proctor</th>
                  <th class="text-left">Lear</th>
                  <th class="text-left">Remark</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in failList" :key="item">
                  <td style="color:red;">{{ item.srno }}</td>
                  <td style="color:red;">{{ item.empid }}</td>
                  <td style="color:red;">{{ item.grno }}</td>
                  <td style="color:red;">
                    {{ item.reason }} - Data is missing
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-dialog>
    </v-row>
    <v-dialog v-model="dialog_send" hide-overlay persistent width="300">
      <v-card color="#4CAF50" dark>
        <v-card-text>
          "Please wait... while file is uploding !!"
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      table_: {
        Proctor: "empid",
        Learner: "grno",
        Remark: "reason",
      },
      dialog_send: false,
      dialog_faildata: false,
      examid: null,
      export_table_headers: {
        "Sr.No.": "srno",
        Proctor: "proctor",
        Learner: "learner",
        Exam: "exam",
      },
      headers: [
        { text: "Sr.no", value: "srno" },
        { text: "Proctor", value: "proctor" },
        { text: "Learner", value: "learner" },
        { text: "Exam", value: "exam" },
        { text: "Is-active", value: "isactive" },
        { text: "Action", value: "edit" },
      ],
      dialog_faildata: false,
      failList: [],
      file: null,
      loading3: false,
      search: "",
      dialog: false,
      editDialog: false,
      examList: [],
      learnerList: [],
      instList: [],
      dataList: [],
      snackbar_msg: "",
      color: "",
      snackbar: false,
      defaultItem: {
        examid: null,
        instid: null,
        lerid: null,
      },
      editedItem: {
        examid: null,
        instid: null,
        lerid: null,
        plmid: null,
        isactive: null,
      },
    };
  },

  mounted() {
    this.onLoad();
  },
  methods: {
    submitFile() {
      if (this.file == null) {
        this.showSnackbar("#b71c1c", "Please select the CSV file!"); // show snackbar
      } else {
        this.dialog_send = true;
        let formData = new FormData();
        formData.append("file", this.file);
        formData.append("examid", this.examid);
        axios
          .post("AdminImport/importProctorData", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            if (res.data.msg == "200") {
              this.dialog_send = false;
              this.failList = res.data.dataInvalid;
              if(this.failList.length!=0){
                this.dialog_faildata = true;
              }else{
              this.showSnackbar(
                "#4caf50",
                "Proctor Assign successfully..."
              );
              }
              this.examid = null;
              this.file = null;

              this.onLoad();
            }
          })
          .catch(function() {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            window.console.log(error);
          })
          .finally(() => {
            this.output_load = false;
          });
        //     }
      }
    }, //end of the fuction
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onLoad() {
      axios
        .post("/AdminImport/assignProctorToLearner")
        .then((res) => {
          if (res.data.msg == "200") {
            this.instList = res.data.int_list;
            this.learnerList = res.data.lear_list;
            this.examList = res.data.examlist;
            this.dataList = res.data.allplm;
          } else {
            this.showSnackbar("#b71c1c", "Data not found...");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar on failure
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
    saveProctor() {
      this.dialog = false;
      axios
        .post("/AdminImport/saveProctor", this.defaultItem)
        .then((res) => {
          if (res.data.msg == "200") {
            this.showSnackbar("#4caf50", "Proctor Assign successfully..."); // show snackbar on success
            this.onLoad();
            this.clear();
          } else if (res.data.msg == "100") {
            this.showSnackbar("#b71c1c", "Record Already Present..."); // show snackbar on success
            this.clear();
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar on failure
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    editProctor() {
      axios
        .post("/AdminImport/editProctorData", this.editedItem)
        .then((res) => {
          if (res.data.msg == "200") {
            this.showSnackbar("#4caf50", "Proctor Update successfully..."); // show snackbar on success
            this.editDialog = false;
            this.onLoad();
          } else if (res.data.msg == "100") {
            this.showSnackbar("#b71c1c", "Record Already Present..."); // show snackbar on success
            this.editDialog = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar on failure
          }
        })
        .catch((error) => {
          window.console.log(error);
        });
    },
    editDialogFunction(item) {
      this.editedItem.examid = item.examid;
      this.editedItem.instid = item.proctorid;
      this.editedItem.lerid = item.learnerid;
      this.editedItem.plmid = item.plmid;
      this.editedItem.isactive = item.isactive;
      this.editDialog = true;
    },
    clear() {
      this.defaultItem.examid = null;
      this.defaultItem.instid = null;
      this.defaultItem.lerid = null;
    },
  },
};
</script>

<style scoped>
.downbtn {
  float: right;
}
.box {
  background-color: #add8e630;
  margin: 8px !important;
  padding: 8px;
}
.flex {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 600px) {
  .flex {
    display: block;
  }
}
.btn {
  margin: 1rem;
  padding-top: 1rem;
}
</style>
